import { FC } from 'react';
import { TableContainer, Table } from '@chakra-ui/react';

import TableHeader from './TableHeader';
import TableBody from './TableBody';

import { ITableProps } from './Table.d';

const CustomTable: FC<ITableProps> = ({
  titleList,
  pathList,
  data,
  isLoading,
}) => {
  return (
    <TableContainer>
      <Table variant="simple">
        <TableHeader titleList={titleList} />
        <TableBody isLoading={isLoading} pathList={pathList} data={data} />
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
